/**
 * SUBNAUTICA CREATURES GAME LOGIC
 * ================================
 * This file now ONLY exports the unique logic and components for this game.
 * All shared configuration data has been moved to the unified config.
 */

import SubnauticaCreaturesHint from '../../components/SubnauticaCreaturesHint/SubnauticaCreaturesHint';
import SubnauticaCreatureDirectory from '../../components/SubnauticaCreatureDirectory/SubnauticaCreatureDirectory';
import SubnauticaCreaturesHowToPlay from '../../components/SubnauticaCreaturesHowToPlay/SubnauticaCreaturesHowToPlay';

const compareCreatures = (guessed, target) => {
  const results = {};
  const simpleFields = ['size', 'behavior', 'biome', 'diet', 'food_restored'];
  simpleFields.forEach(field => {
    results[field] = guessed[field] === target[field] ? 'correct' : 'incorrect';
  });
  return results;
};

const getDisplayValue = (creature, categoryKey) => {
  const value = creature[categoryKey];
  return (value === null || typeof value === 'undefined' || String(value).trim() === '') ? 'None' : String(value);
};

const subnauticaCreaturesLogic = {
  // Keep only what is unique to this game
  categories: [
    { key: 'size', label: 'Size' },
    { key: 'behavior', label: 'Behavior' },
    { key: 'biome', label: 'Biome' },
    { key: 'diet', label: 'Diet' },
    { key: 'food_restored', label: 'Food Restored' }
  ],
  compareFunction: compareCreatures,
  getDisplayValue,
  
  HintComponent: SubnauticaCreaturesHint,
  DirectoryComponent: SubnauticaCreatureDirectory,
  HowToPlayComponent: SubnauticaCreaturesHowToPlay,
  
  renderVictoryDetails: (creature) => (
    <div className="subnautica-creatures-game__creature-description">
      <div><strong>Description:</strong></div>
      <div className="subnautica-creatures-game__description-text">{creature.description}</div>
    </div>
  )
};

export default subnauticaCreaturesLogic;